import { render } from "./toggleBar.vue?vue&type=template&id=6a81f446&scoped=true"
import script from "./toggleBar.vue?vue&type=script&lang=js"
export * from "./toggleBar.vue?vue&type=script&lang=js"

import "./toggleBar.vue?vue&type=style&index=0&id=6a81f446&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a81f446"]])

export default __exports__